import React, {useState} from 'react';
import {MdSportsVolleyball} from 'react-icons/md';
import {clubLogoUrl} from '../../data/clubs';
import {logoKey, useEmbeddedLogos} from '../../data/clubLogos';
import {useSiteConfig} from '../../data/ConfigContext';
import {upgradeToHttps} from '../../utils/html';

/** The embedded base64 logo if available, otherwise the WordPress image, otherwise a volleyball icon. */
const TeamLogo = ({team}: { team: string }) => {
    const config = useSiteConfig();
    const embedded = useEmbeddedLogos();
    const [failed, setFailed] = useState(false);

    if (!config || !embedded) {
        return <span className="team-logo" aria-hidden="true"/>;
    }

    const url = clubLogoUrl(config.clubs, team);
    const src = url && (embedded[logoKey(url)] ?? upgradeToHttps(url));
    if (!src || failed) {
        return <MdSportsVolleyball className="team-logo team-logo--fallback" aria-hidden="true"/>;
    }
    return <img className="team-logo" src={src} alt={`Logo ${team}`} loading="lazy" onError={() => setFailed(true)}/>;
};

export default TeamLogo;
